// extracted by mini-css-extract-plugin
export var menuIcon = "_tq-0";
export var menuIconInline = "_tq-1";